(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        // ───────────────────────────────────────────────────────────────
        // Apply announcement-bar height as top offset if enabled
        const announcementBar = document.querySelector('.announcement-bar-section');
        const utilityBar = announcementBar?.querySelector('.utility-bar');
        if (announcementBar && utilityBar?.dataset.stickyAnnouncementBar === 'true') {
          const height = announcementBar.offsetHeight;
          this.header.style.top = `${height}px`;
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  /**
   * Updates the contents of the shopping cart bubble items count
   */
  if (ENABLE_REBUY_CART) {
    function openRebuyOrFallback(cartIcon) {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        Rebuy.SmartCart.show();
        return;
      }

      if (cartIcon) {
        cartIcon.classList.add('is-loading');
        cartIcon.setAttribute('aria-label', 'Loading cart...');
      }

      var handled = false;
      function done() {
        if (handled) return;
        handled = true;
        if (cartIcon) {
          cartIcon.classList.remove('is-loading');
          cartIcon.removeAttribute('aria-label');
        }
      }

      var fallbackTimeout = setTimeout(function () {
        done();
        // Fall back to native cart drawer
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.style.display = '';
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', function () { drawer.close(); }, { once: true });
          drawer.addEventListener('keyup', function (evt) { if (evt.code === 'Escape') drawer.close(); });
          drawer.open(cartIcon);
        } else {
          window.location.href = '/cart';
        }
      }, 5000);

      var readyHandler = function () {
        clearTimeout(fallbackTimeout);
        done();
        Rebuy.SmartCart.show();
      };
      document.addEventListener('rebuy:smartcart.ready', readyHandler, { once: true });

      // Re-check in case the event already fired between our initial check and the listener
      if (window.Rebuy && window.Rebuy.SmartCart) {
        document.removeEventListener('rebuy:smartcart.ready', readyHandler);
        clearTimeout(fallbackTimeout);
        done();
        Rebuy.SmartCart.show();
      }
    }

    // Use event delegation so it survives innerHTML replacements (e.g. cart-notification.js)
    // and catches all cart links site-wide (cart icon, "View Cart" buttons, quick-order links)
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('a[href$="/cart"]');
      if (!cartLink) return;
      e.preventDefault();
      var cartIcon = cartLink.id === 'cart-icon-bubble' ? cartLink : null;
      openRebuyOrFallback(cartIcon);
    });
  }

  document.addEventListener('rebuy:cart.change', function (event) {
    var cartCountBubble = document.querySelector('.cart-count-bubble');
    if (!cartCountBubble) return;
    var cartData = event && event.detail && event.detail.cart && event.detail.cart.cart;
    if (!cartData) return;
    var itemCount = cartData.item_count || 0;

    if (itemCount > 0) {
      cartCountBubble.innerHTML = '<span aria-hidden="true">' + itemCount + '</span>';
      cartCountBubble.style.display = 'block';
    } else {
      cartCountBubble.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ui-library"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-ui-library]')
  if (root) {
    const labels = {
      fontSize: root.dataset.labelFontSize,
      lineHeight: root.dataset.labelLineHeight,
      letterSpacing: root.dataset.labelLetterSpacing,
      fontWeight: root.dataset.labelFontWeight,
      fontFamily: root.dataset.labelFontFamily,
      rem: root.dataset.labelRem,
      px: root.dataset.labelPx
    }

    const formatNumber = (value) => {
      if (!Number.isFinite(value)) return ''
      const fixed = value.toFixed(2)
      return fixed.replace(/\.00$/, '').replace(/(\.\d)0$/, '$1')
    }

    const updateToken = (selector, text) => {
      const node = root.querySelector(selector)
      if (node) node.textContent = text
    }

    const updateSpecs = () => {
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
      const bodyFontSize = parseFloat(getComputedStyle(document.body).fontSize)
      const textBodySample = root.querySelector('.text-body')
      const textBodySize = textBodySample ? parseFloat(getComputedStyle(textBodySample).fontSize) : null

      updateToken('[data-ui-root]', `1${labels.rem} = ${formatNumber(rootFontSize)}${labels.px}`)
      updateToken('[data-ui-body]', `${formatNumber(bodyFontSize / rootFontSize)}${labels.rem} / ${formatNumber(bodyFontSize)}${labels.px}`)
      if (textBodySize) {
        updateToken('[data-ui-text-body]', `${formatNumber(textBodySize / rootFontSize)}${labels.rem} / ${formatNumber(textBodySize)}${labels.px}`)
      }

      root.querySelectorAll('[data-ui-sample]').forEach((item) => {
        const target = item.querySelector('[data-ui-target]')
        const spec = item.querySelector('[data-ui-spec]')
        if (!target || !spec) return

        const styles = getComputedStyle(target)
        const fontSizePx = parseFloat(styles.fontSize)
        const fontSizeRem = fontSizePx / rootFontSize
        const lineHeightPx = styles.lineHeight === 'normal' ? null : parseFloat(styles.lineHeight)
        const lineHeightRem = lineHeightPx ? lineHeightPx / rootFontSize : null
        const lineHeightRatio = lineHeightPx ? lineHeightPx / fontSizePx : null
        const letterSpacingPx = styles.letterSpacing === 'normal' ? 0 : parseFloat(styles.letterSpacing)
        const letterSpacingRem = letterSpacingPx / rootFontSize
        const fontWeight = styles.fontWeight
        const fontFamily = styles.fontFamily.split(',')[0].replace(/['\"]/g, '').trim()

        const parts = [
          `${labels.fontSize}: ${formatNumber(fontSizeRem)}${labels.rem} / ${formatNumber(fontSizePx)}${labels.px}`,
          lineHeightPx
            ? `${labels.lineHeight}: ${formatNumber(lineHeightRatio)} (${formatNumber(lineHeightRem)}${labels.rem})`
            : `${labels.lineHeight}: ${styles.lineHeight}`,
          `${labels.letterSpacing}: ${formatNumber(letterSpacingRem)}${labels.rem}`,
          `${labels.fontWeight}: ${fontWeight}`,
          `${labels.fontFamily}: ${fontFamily}`
        ]

        spec.textContent = parts.join(' | ')
      })
    }

    const details = root.querySelector('[data-ui-details]')
    if (details) {
      const summary = details.querySelector('summary')
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!document.startViewTransition) return
          event.preventDefault()
          document.startViewTransition(() => {
            details.open = !details.open
          })
        })
      }
    }

    updateSpecs()
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateSpecs)
    }
    window.addEventListener('resize', () => {
      window.requestAnimationFrame(updateSpecs)
    })
  }

  } catch(e) { console.error(e); }
})();
})();
